import React, {useEffect, useMemo, useRef} from "react";
import {UAParser} from "ua-parser-js";
import {
    Box, Button, Card,
    CardContent,
    Container,
    Grid,
    Modal,
    Typography
} from "@mui/material";
import {TitleAppBar} from "~/ui/AppBar/TitleAppBar";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {useHistory, useLocation} from "react-router-dom";
import SafariVideoURL from "~/instructions/install/iOS.mp4";
import ChromeVideoURL from "~/instructions/install/Android.mp4";
import {useHistoryState} from "~/apps/core/utils";


const SafariInstruction = (
    <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
        <Grid item>
            <Card style={{width: "100%"}}>
                <CardContent>
                    <Typography variant="listText" color="primary" display="block">
                        <svg style={{float: "right", clear: "both", marginLeft: "8px", marginBottom: "8px"}} width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.52832 15.6739C9.99023 15.6739 10.3877 15.2911 10.3877 14.8445V3.92379L10.3232 2.32875L11.043 3.08374L12.6758 4.80638C12.8262 4.97652 13.041 5.06159 13.2559 5.06159C13.6963 5.06159 14.04 4.74258 14.04 4.3066C14.04 4.0833 13.9434 3.91316 13.7822 3.75366L10.1514 0.287107C9.93652 0.0744351 9.75391 0 9.52832 0C9.31348 0 9.13086 0.0744351 8.90527 0.287107L5.27441 3.75366C5.11328 3.91316 5.02734 4.0833 5.02734 4.3066C5.02734 4.74258 5.34961 5.06159 5.80078 5.06159C6.00488 5.06159 6.24121 4.97652 6.3916 4.80638L8.01367 3.08374L8.74414 2.32875L8.67969 3.92379V14.8445C8.67969 15.2911 9.06641 15.6739 9.52832 15.6739ZM3.37305 24H15.6943C17.9395 24 19.0674 22.8941 19.0674 20.7036V10.0913C19.0674 7.90075 17.9395 6.79486 15.6943 6.79486H12.6973V8.50687H15.6621C16.7256 8.50687 17.3379 9.08108 17.3379 10.187V20.6079C17.3379 21.7138 16.7256 22.288 15.6621 22.288H3.39453C2.32031 22.288 1.72949 21.7138 1.72949 20.6079V10.187C1.72949 9.08108 2.32031 8.50687 3.39453 8.50687H6.37012V6.79486H3.37305C1.12793 6.79486 0 7.90075 0 10.0913V20.7036C0 22.8941 1.12793 24 3.37305 24Z" fill="#3F79B5"/>
                        </svg>

                        1. Нажмите кнопку в панели браузера
                    </Typography>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img alt="Панель" src="/instructions/install/IOS-panel.jpg"
                             style={{maxHeight: "50px", objectFit: "contain", width: "100%"}}
                        />
                    </Grid>
                </CardContent>
            </Card>
        </Grid>

        <Grid item>
            <Card style={{width: "100%"}}>
                <CardContent>
                    <Typography variant="listText" color="primary" marginBottom="10px" display="block">
                        2. Выберите пункт меню
                    </Typography>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img alt="Пункт меню" src="/instructions/install/IOS-menuitem.jpg"
                             style={{maxHeight: "45px", objectFit: "contain", width: "100%"}}
                        />
                    </Grid>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img width="260px" src="/instructions/install/IOS1.jpg" alt="Снимок экрана"/>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>

        <Grid item>
            <Card style={{width: "100%"}}>
                <CardContent>
                    <Typography variant="listText" color="primary" marginBottom="10px" display="block">
                        3. Нажмите кнопку <span style={{color: "#3F79B5"}}>«Добавить»</span>
                    </Typography>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img width="260px" src="/instructions/install/IOS2.jpg" alt="Снимок экрана"/>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    </Grid>
);

const ChromeInstruction = (
    <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
        <Grid item>
            <Card style={{width: "100%"}}>
                <CardContent>
                    <Typography variant="listText" color="primary" display="block">

                        <svg style={{float: "right", clear: "both", marginLeft: "8px", marginBottom: "8px"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.5 6C12.8807 6 14 4.88071 14 3.5C14 2.11929 12.8807 1 11.5 1C10.1193 1 9 2.11929 9 3.5C9 4.88071 10.1193 6 11.5 6Z" fill="#3F79B5"/>
                            <path d="M11.5 14C12.8807 14 14 12.8807 14 11.5C14 10.1193 12.8807 9 11.5 9C10.1193 9 9 10.1193 9 11.5C9 12.8807 10.1193 14 11.5 14Z" fill="#3F79B5"/>
                            <path d="M11.5 22.5C12.8807 22.5 14 21.3807 14 20C14 18.6193 12.8807 17.5 11.5 17.5C10.1193 17.5 9 18.6193 9 20C9 21.3807 10.1193 22.5 11.5 22.5Z" fill="#3F79B5"/>
                        </svg>


                        1. Нажмите кнопку в панели браузера
                    </Typography>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img alt="Панель" src="/instructions/install/Android-panel.jpg"
                             style={{maxHeight: "60px", objectFit: "contain", width: "100%"}}
                        />
                    </Grid>
                </CardContent>
            </Card>
        </Grid>

        <Grid item>
            <Card style={{width: "100%"}}>
                <CardContent>
                    <Typography variant="listText" color="primary" marginBottom="10px" display="block">
                        2. Выберите пункт меню
                    </Typography>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img alt="Пункт меню" src="/instructions/install/Android-menuitem.jpg"
                             style={{maxHeight: "45px", objectFit: "contain", width: "100%"}}
                        />
                    </Grid>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img width="260px" src="/instructions/install/Android1.jpg"/>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>

        <Grid item>
            <Card style={{width: "100%"}}>
                <CardContent>
                    <Typography variant="listText" color="primary" marginBottom="10px" display="block">
                        3. Нажмите кнопку <span style={{color: "#3F79B5"}}>«Установить»</span>
                    </Typography>

                    <Grid container alignItems="center" justifyContent="center" marginTop="16px">
                        <img width="260px" src="/instructions/install/Android2.jpg"/>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    </Grid>
);


const InstallPage = () => {
    const history = useHistory();
    const location = useLocation();
    const [browser, setBrowser] = useHistoryState({name: "browser", handleBack: false});
    const $video = useRef<HTMLVideoElement>();

    const instruction = {
        "safari": SafariInstruction,
        "mobile safari": SafariInstruction,
        "chrome": ChromeInstruction,
        "chromium": ChromeInstruction
    }[browser] || ChromeInstruction;
    const video = {
        "mobile safari": SafariVideoURL,
        "safari": SafariVideoURL,
        "chrome": ChromeVideoURL,
        "chromium": ChromeVideoURL,
    }[browser] || ChromeVideoURL;

    const showVideo = new URLSearchParams(location.search).has("showVideo");

    const handleBack = () => {
        history.goBack();
    }

    const handleShowVideoClick = () => {
        const params = new URLSearchParams(location.search);
        params.set("showVideo", "");

        history.push({
            ...location,
            search: params.toString(),
        });
    }

    useEffect(() => {
        if (!browser) {
            setBrowser(new UAParser().getBrowser().name?.toLowerCase());
        }
    }, []);

    useEffect(() => {
        if ($video.current) {
            if (showVideo) {
                $video.current.currentTime = 0;
                $video.current.play();
            } else {
                $video.current.pause();
            }
        }
    }, [showVideo])

    return (
        <>
            <TitleAppBar onBack={handleBack} title="Инструкция по установке"/>
            <Box marginTop="56px" pt={2}>
                <Container>
                    {instruction}
                    <Box height="80px"/>
                    <FloatingActions>
                        <Button color="primary" fullWidth onClick={handleShowVideoClick}>
                            Видео инструкция
                        </Button>
                    </FloatingActions>
                </Container>
            </Box>

            <Modal
                open={showVideo}
                keepMounted
            >
                <>
                    <TitleAppBar onBack={handleBack} color="transparent" title="Видео инструкция"/>
                    <Grid container alignItems="center" direction="column" wrap="nowrap" marginTop="56px">
                        <video controls height={window?.innerHeight - 56} ref={$video}>
                            <source src={video} type='video/mp4'/>
                        </video>
                    </Grid>
                </>
            </Modal>
        </>
    );
}


export default InstallPage;